import Vue from 'vue'
import VueRouter from 'vue-router'
import FastClick from 'fastclick'
import './assets/styles/normalize.css'
import App from './views/app.vue'
import routes from './routes'
// import 'swiper/dist/css/swiper.css'
FastClick.attach(document.body)

Vue.use(VueRouter)

let routerOpts = {
    routes,
    mode: 'hash',
    scrollBehavior() {
        return { x: 0, y: 0 }; //对于所有路由导航，简单地让页面滚动到顶部
    },
    base: '/fcp/diandian/'
};

if (process.env.NODE_ENV !== 'production') {
    routerOpts.base = '';
}
window._helpIndex = 0
window._helpItemIndex = 0

const router = new VueRouter(routerOpts);

//测试环境修改当前环境
import TestEnv from './components/testenv'
Vue.use(TestEnv);

new Vue({
    el: '#app',
    render: h => h(App),
    router
});



// WEBPACK FOOTER //
// ./src/index.js